export const getPersistState = (state) => ({
	sections: state.sections,
	moviesList: state.moviesList,
	genresList: state.genresList,
	static_content: state.static_content,
	epg: state.epg,
	channels: state.channels,
	category: state.category,
	home: state.home,
	program_details: state.program_details,
	free_products: state.free_products
});
